<template>
    <Modal
        :opened="opened"
        class="ModalCell"
        :class="{ overflow: overflowDisabled }"
        @close="handleCancel"
    >
        <template #header>
            <div class="flex row-stretch-center">
                <WText
                    tag="span"
                    class="mb-0"
                    :size="22"
                >
                    {{ $t('imports.create.updateField') }}
                </WText>
            </div>
        </template>
        <template #body>
            <CellForm
                :value="value"
                :rowId="rowId"
                :field="field"
                :type="type"
                :options="options"
                :loading="isLoading"
                @input="handleInput"
            />

            <div class="flex row-right-center">
                <WButton
                    :disabled="isLoading"
                    color="secondary"
                    class="mr-1"
                    @click="handleCancel"
                >
                    {{ $t('imports.create.issues.form.cancel') }}
                </WButton>
                <WButton
                    :loading="isLoading"
                    :disabled="isLoading"
                    @click="submit"
                >
                    {{ $t(`imports.create.issues.form.submit`) }}
                </WButton>
            </div>
        </template>
    </Modal>
</template>

<script>
/* eslint-disable no-underscore-dangle */
import VueTypes from 'vue-types'
import {
    Api, apiRequest, rethrowError, notifyError,
} from '@/api'
import { Modal } from '@/components'
import { INPUTS, FIELD_INPUTS } from '@/entities/fields'
import CellForm from './CellForm.vue'

export default {
    name: 'ModalCell',
    components: {
        CellForm,
        Modal,
    },
    props: {
        opened: VueTypes.bool.def(false),
        importId: VueTypes.oneOfType([VueTypes.string, VueTypes.number]),
        row: VueTypes.any,
        col: VueTypes.any,
        selectGroups: VueTypes.any,
        entity: VueTypes.string,
    },
    data () {
        return {
            rowId: undefined,
            value: undefined,
            changes: undefined,
            isLoading: false,
        }
    },
    computed: {
        field () {
            return (this.col || {}).field
        },
        type () {
            return (this.col || {}).type
        },
        options () {
            const { selectGroup } = this.col || {}
            const group = this.selectGroups[selectGroup] || {}
            return Object.keys(group).map(key => ({ key, label: group[key] }))
        },
        overflowDisabled () {
            return FIELD_INPUTS[this.type] === INPUTS.DATE
        },
    },
    watch: {
        opened (value) {
            if (value) this.initialize()
        },
    },
    mounted () {
        this.initialize()
    },
    methods: {
        initialize () {
            const { data = {} } = this.row || {}
            this.rowId = data._inputRowId
            this.value = data[this.field]
            // The API needs the row id even when the field is submitted untouched
            this.changes = { _inputRowId: this.rowId }
        },
        handleInput (changes) {
            this.changes = changes
        },
        handleCancel () {
            this.$emit('onCancel')
        },
        async submit () {
            this.isLoading = true
            apiRequest(Api().imports.editSource(this.importId, {
                type: 'edit',
                row: this.changes,
                ...(this.entity ? { entity: this.entity } : {}),
            }))
                .then(({ data: issues }) => (this.$emit('onResolve', { row: { ...this.row.data, ...this.changes }, issues })))
                .catch(rethrowError(notifyError()))
                .finally(() => (this.isLoading = false))
        },
    },
}
</script>
<style lang="scss" scoped>
.Modal {
    &::v-deep .Dialog {
        overflow: initial;
    }
}
</style>
